import { Grid, styled } from '@mui/material';

export const StyledGrid = styled(Grid)(({ theme }) => ({
  gap: theme.spacing(1),
  width: 'unset',
}));
